import React from "react";


interface Props {
  size?: number;
  color?: string;
}
const RetrospectiveIcon: React.FC<Props> = ({
  size = 24,
  color = "#79808A",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 12C3 7.7574 3 5.6361 4.3176 4.3176C5.637 3 7.7574 3 12 3C16.2426 3 18.3639 3 19.6815 4.3176C21 5.637 21 7.7574 21 12C21 16.2426 21 18.3639 19.6815 19.6815C18.3648 21 16.2426 21 12 21C7.7574 21 5.6361 21 4.3176 19.6815C3 18.3648 3 16.2426 3 12Z"
        stroke={color}
        stroke-width="1.5"
      />
      <path
        d="M7 15.92L8.143 17L11 14.3M7 9.62L8.143 10.7L11 8"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13 9H18M13 15H18"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default RetrospectiveIcon;
